import React, { useContext, useEffect } from 'react';
import { EditWatchContext, IEditWatchContext } from '../../../../editWatchState/editWatchContext';
import { preventDefaultForEnterKey } from 'utils/helpers';
import { Form } from 'antd';
import Text from 'components/Text/Text';
import { SerialNumberField } from './components/SerialNumberField';
import { CustomerField } from './components/CustomerField';
import { RestaurantField } from './components/RestaurantField';
import { IsActiveCheckbox } from './components/IsActiveCheckbox';
import { BtnBlock } from './components/BtnBlock';
import style from './InputFields.module.scss';

export const InputFields: React.FC = () => {
	const {
		changeLoaderStatus,
		changeSerialNumber,
		setIDCustomer,
		setIDRestaurant,
		setDataForSubmit,
		changeTypeOfModalWindow,
		isLoading,
		watchID,
		serialNumber,
		IDSelectedCustomer,
		IDSelectedRestaurant,
		isActive,
	} = useContext<IEditWatchContext>(EditWatchContext);
	const [form] = Form.useForm();

	useEffect(() => {
		form.setFieldsValue({ serialNumber, IDSelectedCustomer, IDSelectedRestaurant });
	}, [serialNumber, IDSelectedCustomer, IDSelectedRestaurant]);

	const submit = () => {
		setDataForSubmit({
			id: watchID,
			serialNumber,
			restaurantId: IDSelectedRestaurant,
		});
		changeTypeOfModalWindow('toConfirmSubmit');
	};

	return (
		<div className={style.container} data-test="InputFields">
			<Form form={form} name="basic" onFinish={submit} onKeyPress={preventDefaultForEnterKey} layout="vertical">
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="serialNumberHeading"
						theme="secondary"
						size="l"
						weight="bold"
						display="inline"
					/>
					<SerialNumberField changeSerialNumber={changeSerialNumber} />
				</div>
				<div className={style.fieldsWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="mainInfoHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<CustomerField setIDCustomer={setIDCustomer} IDSelectedCustomer={IDSelectedCustomer} />
					<RestaurantField
						IDSelectedCustomer={IDSelectedCustomer}
						IDSelectedRestaurant={IDSelectedRestaurant}
						setIDRestaurant={setIDRestaurant}
						changeLoaderStatus={changeLoaderStatus}
					/>
				</div>
				<IsActiveCheckbox isActive={isActive} />
				{!isLoading && <BtnBlock changeTypeOfModalWindow={changeTypeOfModalWindow} />}
			</Form>
		</div>
	);
};
